<template>
  <div>
    <div class="item" @click="changeUrl">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "CommonTabMenuItem",
  props: {
    to: {
      type: String,
      default: ""
    }
  },
  methods: {
    changeUrl() {
      if (this.to) {
        this.$router.push(this.to);
      }
    }
  }
};
</script>

<style lang="stylus" scoped>
.item
  cursor pointer
  letter-spacing 2px
  line-height 40px
  padding 0 25px
  &:hover
    color #1880f4
</style>
